module.exports = __webpack_public_path__ + "img/checkout.40fb5d31.svg";